import React, { useEffect, useRef, useState } from "react";
import Style from "./style.module.css";
import InnerLoader from "../../../../component/ui/loader/inner-loader";
import DataNotFound from "../../../../component/ui/loader/data-not-found";
import {
  Calendar,
  CheckCircle2,
  ListIcon,
  Share2,
  ShieldX,
  Wallet,
  WalletCards,
} from "lucide-react";
import ChevronDownIcon from "../../../../component/icons/chevron-down";
import { motion } from "framer-motion";
import { useApiCall } from "../../../../component/custom-hooks/api-call";
import DynamicFilter from "../../../../component/table/filter-table/dynamic-filter";
import FilterFunnel01Icon from "../../../../component/icons/filter-funnel-01";
import { Alert, Skeleton, Snackbar } from "@mui/material";
import CustomizeTabsPopup from "../../../../component/table/customize-table";
import LayoutTopIcon from "../../../../component/icons/layout-top";
import { Link } from "react-router";
import AccountQuickView from "./popup";
import { CustomDropdown } from "../../../../component/ui/dropdown/CustomDropdown";
import { CustomDropdownButton } from "../../../../component/ui/dropdown/CustomDropdownButton";
import DotsVerticalIcon from "../../../../component/icons/dots-vertical";
import { CustomDropdownMenu } from "../../../../component/ui/dropdown/CustomDropdownMenu";
import { CustomDropdownMenuList } from "../../../../component/ui/dropdown/CustomDropdownMenuList";
import AccountBoard from "./kanban/AccountBoard";
import Tooltip from "../../../../component/ui/tooltip";
import * as XLSX from "xlsx";
import {
  Table,
  TableBody,
  TableCard,
  TableCell,
  TableFilterReturn,
  TableHead,
  TableHeaderWrap,
  TableRow,
} from "../../../../component/table/table-layout";
import StatusChip from "../../../../component/ui/chip/status";
import NewEditIcon from "../../../../component/icons/action-edit-icon";
import NewEyeIcon from "../../../../component/icons/action-eye-icon";
import NewCardIcon from "../../../../component/icons/action-card-icon";
import { CustomDropdownMenuDivider } from "../../../../component/ui/dropdown/CustomDropdownMenuDivider";
import FileCode1Icon from "../../../../component/icons/file-code-1";
import Swal from "sweetalert2";
import dayjs from "dayjs";
import EmployeeDirectoryAddUpdate from "../../../organization/emplyee-directory/add-update";
import AddWallet from "../../../wallets/wallet/add-wallet/add-wallet";
import BulkEdit from "../../../../component/modals/bulk-edit/bulk-edit";

const TeamAccounts = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [apiData, setApiData] = useState([]);
  const [showModalFilterTable, setShowModalFilterTable] = useState(false);
  const [filterReturn, setFilterReturn] = useState([]);
  const [saveFilter, setSaveFilter] = useState([]);
  const [tablePagination, setTablePagination] = useState({});
  const [btnLoader, setBtnLoader] = useState(false);
  const [alertData, setAlertData] = useState({ isShow: false });
  const [brands, setBrands] = useState([]);
  const [tableHeader, setTableHeader] = useState([]);
  const [empPopup, setEmpPopup] = useState(false);
  const [empData, setEmpData] = useState({});
  const [boardFilters, setBoardFilters] = useState([]);
  const [showBoardFilterModal, setShowBoardFilterModal] = useState(false);
  const [groupBy, setGroupBy] = useState(); // default
  const [boardSaveFilters, setBoardSaveFilters] = useState([]);
  const [viewType, setViewType] = useState("list");
  const [showModalCustomizeTabs, setShowModalCustomizeTabs] = useState(false);
  const [showLead, setShowLead] = useState(false);
  const [currentData, setCurrentData] = useState({});

  // deals tab
  const [Clients, setClients] = useState([]);
  const [page, setPage] = useState(1);
  const [hasMoreClients, setHasMoreClients] = useState(true);
  const [isLoadingClients, setIsLoadingClients] = useState(false);
  const [usersList, setUsers] = useState([]);
  const [loadingUsers, setLoadingUsers] = useState(false);
  const [PackageList, setPackageList] = useState([]);
  const [DealStages, setDealStages] = useState([]);
  const [products, setProducts] = useState([]);

  const [country, setCountry] = useState([]);
  const [subProducts, setSubProducts] = useState([]);
  const [packages, setPackages] = useState([]);

  const [selectedAccounts, setSelectedAccounts] = useState([]);
  const [exportTo, setExportTo] = useState(false);

  const [pageCount, setPageCount] = useState(1);
  const [pageItemsCount, setPageItemsCount] = useState(10);
  const [sortFields, setSortFields] = useState([]);

  // for bulk edit
  const [bulkDataChange, setBulkDataChange] = useState(false);
  const [bulkDatavalue, setBulkDatavalue] = useState("");

  // add wallet
  const [addWalletPopup, setAddWalletPopup] = useState(false);
  const [selectedUser, setSelectedUser] = useState(false);

  const bulkSelectChange = (e) => {
    console.log("sel", selectedAccounts);
    setBulkDatavalue(e);
    if (!e) {
      return;
    }

    if (e == "changeData") {
      setBulkDataChange(true);
    }
  };

  const toggleSelectAll = (checked) => {
    if (checked) {
      setSelectedAccounts(apiData.map((d) => d.userid));
    } else {
      setSelectedAccounts([]);
    }
  };

  const toggleSelectRow = (userId) => {
    setSelectedAccounts((prev) =>
      prev.includes(userId)
        ? prev.filter((id) => id !== userId)
        : [...prev, userId]
    );
  };

  const handleExport = async (type, localData = null) => {
    try {
      // ✅ If user already selected rows
      if (localData && localData.length > 0) {
        exportData(localData, type);
        return;
      }

      const filters = filterReturn || [];
      const page = 1;
      const page_quantity = "all";

      const data = { page, page_quantity, filters };

      Swal.fire({
        title: "Exporting Accounts...",
        text: "Please wait while we export your data.",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      // 🧩 Convert filters array → object
      const filtersObj = data.filters.reduce((acc, f) => {
        if (f.value !== "" && f.value !== null && f.value !== undefined) {
          acc[f.field] = f.value;
        }
        return acc;
      }, {});

      const transformed = {
        page_quantity: String(data.page_quantity || ""),
        page: String(data.page || "1"),
        ...filtersObj,
      };

      const apiData = JSON.stringify(transformed);

      // 🧠 API call — use your actual endpoint
      const res = await apiCall({
        url: `accounts/accounts-list`,
        method: "post",
        data: apiData,
      });

      const accountsData = res?.data || res?.accounts || [];
      if (!accountsData?.length) {
        Swal.fire({
          title: "Warning!",
          text: "No account data available to export.",
          icon: "warning",
          confirmButtonText: "OK",
          buttonsStyling: false,
          customClass: { confirmButton: Style.customSwalBtn },
        });
        return;
      }

      exportData(accountsData, type);
    } catch (error) {
      console.error("Export Error:", error);
      Swal.fire({
        title: "Error!",
        text: "Something went wrong while exporting.",
        icon: "error",
        confirmButtonText: "OK",
        buttonsStyling: false,
        customClass: { confirmButton: Style.customSwalBtn },
      });
    }
  };

  const exportData = (data, type) => {
    // 🧩 Get visible table columns
    const visibleColumns = tableHeader
      ?.filter((col) => col.is_visible === 1 && col.show == 1)
      ?.map((col) => ({ key: col.key, label: col.value }));

    const formattedData = data.map((row) => {
      const obj = {};

      // ✅ Always include key info
      obj["Account Name"] =
        row?.name && row.name !== "0" && row.name.trim() !== ""
          ? row.name
          : row?.account_name || "-";
      obj["Email"] = row?.email || "-";
      obj["Phone"] = row?.phone || "-";

      visibleColumns.forEach(({ key, label }) => {
        if (["name", "email", "phone"].includes(key)) return; // skip duplicates

        if (key === "assigned") {
          obj[label || "Assigned Users"] = Array.isArray(row.assigned_users)
            ? row.assigned_users.map((u) => u.name).join(", ")
            : "-";
        } else if (key === "verified") {
          obj[label || "Verified"] = row[key] == "1" ? "Yes" : "No";
        } else if (key === "active") {
          obj[label || "Active"] = row[key] == "1" ? "Active" : "Inactive";
        } else if (key === "last_comment") {
          obj[label || "Last Comment"] = row?.last_comment?.comment || "--";
        } else if (["created_at", "signupdate"].includes(key)) {
          obj[label || key] = row[key]
            ? dayjs(row[key]).format("DD-MMM-YYYY")
            : "-";
        } else {
          obj[label || key] = row[key] ?? "--";
        }
      });

      return obj;
    });

    // 📁 File name
    const fileName = `accounts_${new Date()
      .toISOString()
      .slice(0, 19)
      .replace(/[:T]/g, "-")}`;

    // 💾 Export logic
    if (type === "csv") {
      const worksheet = XLSX.utils.json_to_sheet(formattedData);
      const csvContent = XLSX.utils.sheet_to_csv(worksheet);
      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `${fileName}.csv`;
      link.click();
    } else if (type === "excel") {
      const worksheet = XLSX.utils.json_to_sheet(formattedData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Accounts");
      XLSX.writeFile(workbook, `${fileName}.xlsx`);
    }

    Swal.fire({
      title: "Success!",
      text: "Account data exported successfully.",
      icon: "success",
      confirmButtonText: "OK",
      buttonsStyling: false,
      customClass: { confirmButton: Style.customSwalBtn },
    });
  };

  const handleClose = () => {
    setAlertData({ isShow: false });
  };

  const getBoardFilter = (val) => {
    setBoardSaveFilters(val);
  };

  const apiCall = useApiCall();

  useEffect(() => {
    getData({});
    getProducts();
    DealPackage();
    DealStage();
    fetchUsers();
    Countries();
    getBrands();
  }, []);

  const getSubProducts = async (productId) => {
    if (!productId) return;
    try {
      const res = await apiCall({
        method: "get",
        url: `products/get-sub-products/${productId}`,
      });
      setSubProducts(res?.data || []);
    } catch (error) {
      console.error("Error fetching sub products:", error);
    }
  };

  const getBrands = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: "brands/brands-list?is_paginate=0",
      });

      setBrands(res?.data || []);
    } catch (error) {
      console.warn("Error fetching brands:", error);
    }
  };

  const getPackages = async (subProductId) => {
    if (!subProductId) return;
    try {
      const res = await apiCall({
        method: "get",
        url: `products/get-sub-product-packages/${subProductId}`,
      });
      setPackages(res?.data || []);
    } catch (error) {
      console.error("Error fetching packages:", error);
    }
  };

  const Countries = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: `location/get-countries`,
      });
      setCountry(res?.data);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const fetchUsers = async () => {
    if (loadingUsers) return;
    setLoadingUsers(true);

    try {
      const res = await apiCall({
        method: "get",
        url: `users/agents-list`,
      });

      console.log("Users API Response ===>", res);
      const newUsers = res?.agents || res?.customers || res?.data || [];
      setUsers(newUsers);
    } catch (err) {
      console.error("Error fetching users", err);
    } finally {
      setLoadingUsers(false);
    }
  };

  const loadClients = async (pageNum = 1, search = "") => {
    if (isLoadingClients || !hasMoreClients) return;
    setIsLoadingClients(true);
    try {
      const res = await apiCall({
        method: "get",
        url: `users/customers-list?page=${pageNum}&limit=10&search=${encodeURIComponent(
          search
        )}`,
      });

      const newClients = res?.customers || [];
      if (pageNum === 1) {
        setClients(newClients); // replace results when searching
      } else if (newClients.length === 0) {
        setHasMoreClients(false);
      } else {
        setClients((prev) => [...prev, ...newClients]);
        setPage(pageNum);
      }
    } catch (err) {
      console.error("Error fetching users", err);
    } finally {
      setIsLoadingClients(false);
    }
  };

  const getProducts = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: "products/products-list?is_paginate=0",
      });

      setProducts(res?.data || []);
    } catch (error) {
      console.warn("Error fetching Products:", error);
    }
  };

  const DealPackage = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: `brands/brand-packages-list?is_paginate=0`,
      });

      setPackageList(res.data);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const DealStage = async () => {
    try {
      const res = await apiCall({
        method: "get",
        url: `dealstages/deal-stages-list`,
      });

      // filter out "Won" and "Lost"
      const filteredStages = res.data.filter(
        (stage) => stage.name !== "Won" && stage.name !== "Lost"
      );

      setDealStages(filteredStages);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const getData = async ({
    filter = filterReturn,
    page,
    page_quantity = pageItemsCount,
  }) => {
    if (!page) {
      setIsLoading(true);
    }
    
    let extraUrl = `?page=${page || 1}&page_quantity=${page_quantity}`;

    for (let i = 0; i < filter?.length; i++) {
      if (filter[i]?.name && filter[i]?.value !== undefined) {
        extraUrl += `&${filter[i]?.name}=${filter[i]?.value}`;
      }
    }

    try {
      const res = await apiCall({
        method: "get",
        url: `accounts/accounts-list${extraUrl}`,
       
      });
      if (page) {
        setApiData((prev) => [...prev, ...res.data]);
      } else {
        setApiData(res.data);
      }
      setTableHeader(res?.applied_headers);
      setSaveFilter(res?.custom_filters);

      setTablePagination(res?.pagination);
      setBtnLoader(false);
      setIsLoading(false);
    } catch (error) {
      console.warn("Error : ", error);
    }
  };

  const onSuccess = (message) => {
    setAlertData({ isShow: true, type: "success", message: message });
    getData({});
    setShowLead(false);
    setCurrentData({});

    setAddWalletPopup(false);
    setSelectedUser({});
  };

  const onError = (message) => {
    setAlertData({ isShow: true, type: "error", message: message });
  };

  

  const filterModalData = [
    {
      name: "name",
      label: "Name",
      options: ["is", "contains"],
      selectedOpt: "is,contains",
      value: "",
      type: "text",
      dropdownKey: "label",
      dropdownVal: "value",
      betweenType: "date",
    },
    {
      name: "email",
      label: "Email",
      options: ["is", "contains"],
      selectedOpt: "is,contains",
      value: "",
      type: "text",
      dropdownKey: "label",
      dropdownVal: "value",
      betweenType: "date",
    },

    {
      name: "source",
      label: "Product",
      options: ["is"],
      selectedOpt: "is",
      value: "",
      type: "dropdown",
      dropdown: [
        { label: "Logo", value: "logo" },
        { label: "Web", value: "web" },
      ],
      dropdownKey: "label",
      dropdownVal: "value",
      betweenType: "date",
    },

    {
      name: "signuptime",
      label: "Date",
      options: ["is", "between"],
      selectedOpt: "is",
      value: "",
      type: "date",
      dropdownKey: "label",
      dropdownVal: "value",
      betweenType: "date",
    },
  ];

  const editLead = (ele) => {
    setCurrentData(ele);
    setShowLead(true);
  };

  const getBoardFilterData = () => {
    if (groupBy === "page_source") return filterModalData;
    return filterModalData; // default
  };

  const tableRef = useRef(null);

  return (
    <>
      <div className={Style.mainBody}>
        <div className={Style.teamSpaceDashboard}>
          <div className={Style.teamSpaceDashboard_main}>
            <div className={Style.teamSpaceDashboard_body}>
              <TableFilterReturn
                filterReturn={viewType === "list" ? filterReturn : boardFilters}
                onChange={(allFilter) => {
                  if (viewType == "list") {
                    setFilterReturn(allFilter);
                  } else {
                    setBoardFilters(allFilter);
                  }
                  getData({ filter: allFilter });
                }}
              />

              {/* HEADER */}
              <div className={Style.empDirectory_header}>
                <div className={Style.empDirectory_header_left}>
                  {viewType === "list" ? (
                    <div className={Style.bpfl_select}>
                      <select
                        onChange={(e) => {
                          getData({ page_quantity: e?.target.value });
                          setPageCount(1);
                          setPageItemsCount(e?.target.value);
                        }}
                      >
                        <option value="10">Account View 10</option>
                        <option value="25">Account View 25</option>
                        <option value="50">Account View 50</option>
                        <option value="100">Account View 100</option>
                        <option value="all">Account View all</option>
                      </select>
                    </div>
                  ) : (
                    <div className="text-xl font-bold pl-3 flex items-center gap-1 leading-10 ">
                      Team Pipeline
                    </div>
                  )}

                  {selectedAccounts?.length > 0 && viewType === "list" ? (
                    <motion.div
                      initial={{ opacity: 0 }}
                      animate={{ opacity: 1 }}
                      className={Style.bpfl_select}
                    >
                      <select
                        value={bulkDatavalue}
                        onChange={(e) => {
                          bulkSelectChange(e.target.value);
                        }}
                      >
                        <option value="" disabled>
                          Action
                        </option>
                        <option value="changeData">Change data</option>
                        <option value="sendBulkEmail" disabled>
                          Send bulk email
                        </option>
                        
                      </select>
                    </motion.div>
                  ) : null}
                </div>

                <div className={Style.empDirectory_header_right}>
                  <div className={Style.bpfl_action}>
                    <Tooltip
                      className={Style.bpfl_actionItems}
                      content={"Table Filter"}
                      position={"left center"}
                    >
                      <div
                        className={`${Style.bpfl_actionBtn} ${
                          (
                            viewType === "kanban"
                              ? boardFilters.length
                              : filterReturn.length
                          )
                            ? Style.active
                            : ""
                        }`}
                        onClick={() => {
                          if (viewType === "list")
                            setShowModalFilterTable(true); // list view ke liye
                          if (viewType === "kanban")
                            setShowBoardFilterModal(true); // board view ke liye
                        }}
                      >
                        <div className={Style.icon}>
                          <FilterFunnel01Icon />
                        </div>
                      </div>
                    </Tooltip>

                    {/* List View Button */}
                    <Tooltip
                      className={`${Style.bpfl_actionItems}`}
                      content={"list view"}
                      position={"left center"}
                    >
                      <div
                        className={`${Style.bpfl_actionBtn} ${
                          viewType === "list" ? Style.active : ""
                        }`}
                        onClick={() => {
                          setViewType("list");
                          setGroupBy();
                        }}
                      >
                        <div className={Style.icon}>
                          <ListIcon size={16} />
                        </div>
                      </div>
                    </Tooltip>

                    <Tooltip
                      className={`${Style.bpfl_actionItems}`}
                      content={"Customize Table"}
                      position={"left center"}
                    >
                      <div
                        className={`${Style.bpfl_actionBtn} ${
                          viewType === "kanban" ? Style.disabled : ""
                        }`}
                        onClick={() => {
                          if (viewType !== "kanban")
                            setShowModalCustomizeTabs(true);
                        }}
                      >
                        <div className={Style.icon}>
                          <LayoutTopIcon />
                        </div>
                      </div>
                    </Tooltip>

                    <CustomDropdown
                      position="bottom-right"
                      className={`myDropdown`}
                    >
                      <CustomDropdownButton
                        arrow={false}
                        className="btnClass"
                        disabled={viewType === "list"} // <-- disable button itself>
                      >
                        {" "}
                        <DotsVerticalIcon />
                      </CustomDropdownButton>

                      <CustomDropdownMenu>
                        {groupBy != "page_source" && (
                          <CustomDropdownMenuList
                            onClick={() => {
                              setGroupBy("page_source");
                              setViewType("kanban");
                            }}
                          >
                            <div className="d-flex align-items-center gap-1">
                              <Share2 size={14} /> By Lead Source
                            </div>
                          </CustomDropdownMenuList>
                        )}

                        {groupBy != "created_time" && (
                          <CustomDropdownMenuList
                            onClick={() => {
                              setGroupBy("created_time");
                              setViewType("kanban");
                            }}
                          >
                            <div className="d-flex align-items-center gap-1">
                              <Calendar size={14} /> By Created Time
                            </div>
                          </CustomDropdownMenuList>
                        )}

                        {viewType == "list" ? (
                          <>
                            <CustomDropdownMenuDivider />

                            <CustomDropdownMenuList
                              className={Style.CustomDropdownMenuList}
                              closed={false}
                            >
                              <div
                                className={Style.CustomDropdownMenuListBtn}
                                onClick={() => setExportTo(!exportTo)}
                              >
                                <div className="">
                                  <LayoutTopIcon /> Export to
                                </div>
                                <div
                                  className={`${Style.dropArrow} ${
                                    exportTo ? Style.isActive : null
                                  }`}
                                >
                                  <ChevronDownIcon />
                                </div>
                              </div>

                              {exportTo ? (
                                <div className={Style.subItemMenu}>
                                  <CustomDropdownMenuList
                                    className={Style.subItemList}
                                    onClick={() => {
                                      const dataToExport =
                                        selectedAccounts.length > 0
                                          ? apiData.filter((d) =>
                                              selectedAccounts.includes(
                                                d.userid
                                              )
                                            )
                                          : apiData;

                                      // ✅ Call the new unified export function
                                      handleExport("csv", dataToExport);
                                    }}
                                  >
                                    <div className="d-flex align-items-center gap-1">
                                      <FileCode1Icon /> CSV
                                    </div>
                                  </CustomDropdownMenuList>

                                  <CustomDropdownMenuList
                                    className={Style.subItemList}
                                    onClick={() => {
                                      const dataToExport =
                                        selectedAccounts.length > 0
                                          ? apiData.filter((d) =>
                                              selectedAccounts.includes(
                                                d.userid
                                              )
                                            )
                                          : apiData;

                                      // ✅ Call the new unified export function
                                      handleExport("excel", dataToExport);
                                    }}
                                  >
                                    <div className="d-flex align-items-center gap-1">
                                      <FileCode1Icon /> XLSX
                                    </div>
                                  </CustomDropdownMenuList>
                                </div>
                              ) : null}
                            </CustomDropdownMenuList>
                          </>
                        ) : null}
                      </CustomDropdownMenu>
                    </CustomDropdown>
                  </div>
                </div>
              </div>

              {/* BODY */}
              <div
                className={Style.empDirectory_body}
                style={
                  viewType == "list"
                    ? { height: "calc(100vh - 100px)" }
                    : { height: "calc(100vh - 50px)" }
                }
              >
                {viewType === "list" ? (
                  isLoading ? (
                    <InnerLoader />
                  ) : !apiData?.length ? (
                    <div className="flex justify-center items-center w-full h-full">
                      <DataNotFound title={"Account"} />
                    </div>
                  ) : (
                    <>
                      <TableCard ref={tableRef}>
                        <Table>
                          <TableHead>
                            <TableRow>
                              <TableCell header sticky>
                                <div className="flex gap-2 items-center">
                                  <div className={Style.tableCheckBox}>
                                    <label className={Style.custom_checkbox}>
                                      <input
                                        type="checkbox"
                                        checked={
                                          apiData.length > 0 &&
                                          selectedAccounts.length ===
                                            apiData.length
                                        }
                                        className={Style.customCheckbox}
                                        onChange={(e) =>
                                          toggleSelectAll(e.target.checked)
                                        }
                                      />
                                      <span className={Style.checkmark}></span>
                                    </label>
                                  </div>
                                  <TableHeaderWrap>
                                    <span className="pl-[50px]">Name</span>
                                  </TableHeaderWrap>
                                </div>
                              </TableCell>
                              {tableHeader?.map((eachHead, index) =>
                                eachHead.is_visible === 1 &&
                                eachHead?.show == 1 ? (
                                  <TableCell header key={index}>
                                    <TableHeaderWrap>
                                      <span>{eachHead?.value}</span>
                                    </TableHeaderWrap>
                                  </TableCell>
                                ) : null
                              )}
                            </TableRow>
                          </TableHead>

                          <TableBody>
                            {apiData?.map((eachList, index) => {
                              return (
                                <TableRow key={`${index}`}>
                                  <TableCell sticky>
                                    <div
                                      className={`${Style.tableActionArea} !gap-4`}
                                    >
                                      <div className="flex gap-2 items-center">
                                        <div className={Style.tableCheckBox}>
                                          <label
                                            className={Style.custom_checkbox}
                                          >
                                            <input
                                              type="checkbox"
                                              className={Style.customCheckbox}
                                              checked={selectedAccounts.includes(
                                                eachList.userid
                                              )}
                                              onChange={() =>
                                                toggleSelectRow(eachList.userid)
                                              }
                                            />
                                            <span
                                              className={Style.checkmark}
                                            ></span>
                                          </label>
                                        </div>

                                        <div className="flex items-center gap-3">
                                          <div>
                                            {eachList?.userimg ? (
                                              <img
                                                className="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium object-cover object-center"
                                                src={eachList?.userimg}
                                                alt={eachList?.name}
                                                onError={(e) => {
                                                  e.target.classList.add(
                                                    "hidden"
                                                  );
                                                  if (e.target.parentElement) {
                                                    e.target.parentElement.innerHTML = `
                                            <div class="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium">
                                              ${
                                                eachList?.name?.split(
                                                  " "
                                                )[0]?.[0] || ""
                                              }${
                                                      eachList?.name?.split(
                                                        " "
                                                      )[1]?.[0] || ""
                                                    }
                                            </div>`;
                                                  }
                                                }}
                                              />
                                            ) : (
                                              <div className="h-9 w-9 shrink-0 rounded-full bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium">
                                                {eachList?.name?.split(" ")[0]
                                                  ? eachList?.name?.split(
                                                      " "
                                                    )[0][0]
                                                  : ""}
                                                {eachList?.name?.split(" ")[1]
                                                  ? eachList?.name?.split(
                                                      " "
                                                    )[1][0]
                                                  : ""}
                                              </div>
                                            )}
                                          </div>
                                          <div>
                                            <div className="font-medium leading-5">
                                              {eachList?.name}
                                            </div>
                                          </div>
                                        </div>
                                      </div>

                                      <div
                                        className={
                                          Style.tableActionAreaBtnGrpup
                                        }
                                      >
                                        <div
                                          className={
                                            "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba()] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                          }
                                          onClick={() => {
                                            editLead(eachList);
                                          }}
                                        >
                                          <div
                                            className={Style.icon}
                                            style={{ color: "#FF9500" }}
                                          >
                                            <NewEditIcon className="h-4.5 w-4.5" />
                                          </div>
                                        </div>

                                        <div
                                          className={
                                            "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba(255,255,255,0.2)] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                          }
                                          onClick={() => {
                                            setEmpPopup(true);
                                            setEmpData(eachList);
                                          }}
                                        >
                                          <div
                                            className={Style.icon}
                                            style={{ color: "#007AFF" }}
                                          >
                                            <NewEyeIcon className="h-4.5 w-4.5" />
                                          </div>
                                        </div>

                                        <Link
                                          to={`/accounts/account-details/${eachList?.userid}`}
                                          className={
                                            "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba(255,255,255,0.2)] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                          }
                                        >
                                          <div
                                            className={Style.icon}
                                            style={{ color: "#34C759" }}
                                          >
                                            <NewCardIcon className="h-4.5 w-4.5" />
                                          </div>
                                        </Link>

                                        <Tooltip
                                          content={
                                            eachList?.schedules
                                              ? `Last schedule: ${eachList?.schedules?.created_at}`
                                              : "No schedule yet"
                                          }
                                          position="top center"
                                          className={Style.btn}
                                        >
                                          <div
                                            className={
                                              "w-7 h-7 flex items-center justify-center rounded-md bg-[rgba(255,255,255,0.2)] shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                            }
                                          >
                                            {eachList?.schedules ? (
                                              <CheckCircle2 className="h-4 w-4 text-emerald-500" />
                                            ) : (
                                              <ShieldX className="h-4 w-4 text-amber-500" />
                                            )}
                                          </div>
                                        </Tooltip>

                                        {eachList?.wallet_id ? (
                                          <Tooltip
                                            content="View Wallet"
                                            position="top center"
                                            className={Style.btn}
                                          >
                                            <Link
                                              to={`/wallets/wallet/${eachList.wallet_id}`}
                                              className="w-7 h-7 flex items-center justify-center rounded-md bg-white shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300"
                                            >
                                              <WalletCards className="h-4.5 w-4.5 text-green-500" />
                                            </Link>
                                          </Tooltip>
                                        ) : (
                                          <Tooltip
                                            content="Add Wallet"
                                            position="top center"
                                            className={Style.btn}
                                          >
                                            <div
                                              onClick={() => {
                                                setAddWalletPopup(true);
                                                setSelectedUser(
                                                  eachList?.userid
                                                );
                                              }}
                                              className="w-7 h-7 flex items-center justify-center rounded-md bg-white shadow-[0_4px_12px_rgba(0,0,0,0.08)] border border-gray-100 hover:scale-105 transition-transform duration-300 cursor-pointer"
                                            >
                                              <Wallet className="h-4.5 w-4.5 text-gray-500" />
                                            </div>
                                          </Tooltip>
                                        )}
                                      </div>
                                    </div>
                                  </TableCell>
                                  {tableHeader?.map((eachHead, i) =>
                                    eachHead.is_visible === 1 &&
                                    eachHead?.show == 1 ? (
                                      <>
                                        {eachHead.key === "verified" ? (
                                          <TableCell
                                            key={`${i}-${index}`}
                                            className={`text-center capitalize`}
                                          >
                                            {eachList[eachHead?.key] == "1" ? (
                                              <StatusChip color="green">
                                                Verified
                                              </StatusChip>
                                            ) : eachList[eachHead?.key] ==
                                              "0" ? (
                                              <StatusChip color="red">
                                                Not Verified
                                              </StatusChip>
                                            ) : (
                                              "--"
                                            )}
                                          </TableCell>
                                        ) : eachHead.key == "email" ? (
                                          <TableCell key={`td-${i}`}>
                                            {eachList[eachHead?.key] ? (
                                              <a
                                                href={
                                                  `mailto:${
                                                    eachList[eachHead?.key]
                                                  }` || ""
                                                }
                                              >
                                                {eachList[eachHead?.key] ||
                                                  "--"}
                                              </a>
                                            ) : (
                                              "--"
                                            )}
                                          </TableCell>
                                        ) : eachHead.key == "active" ? (
                                          <TableCell
                                            key={`${i}-${index}`}
                                            className={`text-center capitalize`}
                                          >
                                            {eachList[eachHead?.key] == "1" ? (
                                              <StatusChip color="green">
                                                Active
                                              </StatusChip>
                                            ) : eachList[eachHead?.key] ==
                                              "0" ? (
                                              <StatusChip color="red">
                                                Not Active
                                              </StatusChip>
                                            ) : (
                                              "--"
                                            )}
                                          </TableCell>
                                        ) : eachHead?.key == "signupdate" ||
                                          eachHead?.key === "created_at" ? (
                                          <TableCell key={`${i}-${index}`}>
                                            {eachList?.[eachHead?.key] ?? "--"}
                                          </TableCell>
                                        ) : eachHead.key === "assigned" ? (
                                          <TableCell key={`${i}-${index}`}>
                                            <div className="flex">
                                              {Array.isArray(
                                                eachList?.assigned_users
                                              ) &&
                                              eachList.assigned_users.length >
                                                0 ? (
                                                eachList.assigned_users.map(
                                                  (user, idx) => (
                                                    <Tooltip
                                                      key={idx}
                                                      content={user.name}
                                                      position="top center"
                                                    >
                                                      <div
                                                        className={`relative ${
                                                          idx !== 0
                                                            ? "-ml-2"
                                                            : ""
                                                        }`}
                                                      >
                                                        {user?.userimg ? (
                                                          <img
                                                            src={user.userimg}
                                                            alt={user.name}
                                                            className="h-8 w-8 rounded-full border-2 border-white object-cover object-center shadow-sm bg-white"
                                                            onError={(e) => {
                                                              e.target.onerror =
                                                                null;
                                                              e.target.style.display =
                                                                "none";
                                                              const fallback =
                                                                document.createElement(
                                                                  "div"
                                                                );
                                                              fallback.className =
                                                                "h-8 w-8 flex items-center justify-center rounded-full bg-gray-300 from-indigo-500/20 to-emerald-500/20 text-xs font-medium border-2 border-white shadow-sm";
                                                              fallback.innerText =
                                                                (
                                                                  (user?.name?.split(
                                                                    " "
                                                                  )[0]?.[0] ||
                                                                    "") +
                                                                  (user?.name?.split(
                                                                    " "
                                                                  )[1]?.[0] ||
                                                                    "")
                                                                ).toUpperCase();
                                                              e.target.parentElement.appendChild(
                                                                fallback
                                                              );
                                                            }}
                                                          />
                                                        ) : (
                                                          <div className="h-8 w-8 flex items-center justify-center rounded-full bg-gray-300 from-indigo-500/20 to-emerald-500/20 text-xs font-medium border-2 border-white shadow-sm">
                                                            {(user?.name?.split(
                                                              " "
                                                            )[0]?.[0] || "") +
                                                              (user?.name?.split(
                                                                " "
                                                              )[1]?.[0] || "")}
                                                          </div>
                                                        )}
                                                      </div>
                                                    </Tooltip>
                                                  )
                                                )
                                              ) : (
                                                <span className="text-gray-400 text-sm">
                                                  --
                                                </span>
                                              )}
                                            </div>
                                          </TableCell>
                                        ) : eachHead?.key === "last_comment" ? (
                                          <TableCell key={`${i}-${index}`}>
                                            {eachList?.last_comment?.comment ??
                                              "--"}
                                          </TableCell>
                                        ) : (
                                          <TableCell key={`${i}-${index}`}>
                                            {eachList[eachHead?.key] ?? "--"}
                                          </TableCell>
                                        )}
                                      </>
                                    ) : null
                                  )}
                                </TableRow>
                              );
                            })}
                          </TableBody>
                        </Table>
                      </TableCard>
                    </>
                  )
                ) : (
                  <AccountBoard
                    filters={boardFilters}
                    groupBy={groupBy}
                    sendFilters={getBoardFilter}
                    ClientList={Clients}
                    UserList={usersList}
                    onLoadMoreClients={() => loadClients(page + 1)}
                    hasMoreClients={hasMoreClients}
                    isLoadingClients={isLoadingClients}
                    ProductList={products}
                    PackageList={PackageList}
                    DealStages={DealStages}
                    country={country}
                    SubProductList={subProducts}
                    fetchSubProducts={getSubProducts}
                    fetchPackages={getPackages}
                    CustomerData={currentData}
                    BrandList={brands}
                  />
                )}
              </div>

              {/* FOOTER */}
              {viewType == "list" ? (
                <>
                  {!isLoading ? (
                    apiData?.length > 0 ? (
                      <div
                        className={Style.table_footer}
                        style={{ alignItems: "center" }}
                      >
                        <div className={Style.table_footer_left}>
                          {`showing 1 to ${apiData?.length} of ${tablePagination?.total}`}
                        </div>
                        {tablePagination ? (
                          <div className={Style.empDirectory_footer}>
                            {tablePagination?.next_page_url ? (
                              <button
                                className={Style.loadMoreBtn}
                                onClick={() => {
                                  if (btnLoader) return;
                                  // setPageCount(pageCount + 1);
                                  setBtnLoader(true);
                                  // filterData({ page: pageCount + 1, btnCall: true });
                                  getData({
                                    page: tablePagination?.next_page_url,
                                  });
                                }}
                              >
                                {btnLoader ? (
                                  <InnerLoader
                                    className={Style.loader}
                                    textStatus={false}
                                  />
                                ) : (
                                  "Load More"
                                )}
                              </button>
                            ) : null}
                          </div>
                        ) : null}

                        <div
                          className={`${Style.table_footer_left} ${Style.rightText}`}
                        ></div>
                      </div>
                    ) : null
                  ) : (
                    <div
                      className={Style.table_footer}
                      style={{ alignItems: "center" }}
                    >
                      <div className={Style.table_footer_left}>
                        <Skeleton width={"50%"} height={15} />
                      </div>

                      <div className={Style.empDirectory_footer}>
                        <Skeleton width={"180px"} height={40} />
                      </div>

                      <div
                        className={`${Style.table_footer_left} ${Style.rightText}`}
                      ></div>
                    </div>
                  )}
                </>
              ) : null}
            </div>
          </div>
        </div>
      </div>

      {showModalFilterTable && (
        <DynamicFilter
          data={filterModalData}
          onClose={() => setShowModalFilterTable(false)}
          returnData={filterReturn}
          onSave={(filters) => {
            getData({ filter: filters });
            setShowModalFilterTable(false);
            setFilterReturn(filters);
          }}
          saveFilter={saveFilter}
          apiUrl="accounts-list"
        />
      )}

      {showBoardFilterModal && (
        <DynamicFilter
          data={getBoardFilterData()}
          onClose={() => setShowBoardFilterModal(false)}
          returnData={boardFilters}
          onSave={(filters) => {
            setBoardFilters(filters);
            setShowBoardFilterModal(false);
          }}
          saveFilter={boardSaveFilters}
          apiUrl={`accounts-kanban?group_by=${groupBy}`}
        />
      )}

      {showModalCustomizeTabs && (
        <CustomizeTabsPopup
          data={tableHeader}
          onClose={() => {
            setShowModalCustomizeTabs(false);
            const table = tableRef?.current;
            if (table) {
              table.style.zIndex = 1;
            }
          }}
          onPreview={(updatedHeaders) => {
            setTableHeader(updatedHeaders);
            const table = tableRef?.current;
            table.style.zIndex = 100;
          }}
          onPreviewClose={() => {
            const table = tableRef?.current;
            table.style.zIndex = 1;
          }}
          onSave={(saveHeaders) => {
            setTableHeader(saveHeaders);
            const table = tableRef?.current;
            if (table) {
              table.style.zIndex = 1;
            }
          }}
          apiUrl="accounts-list"
        />
      )}

      {empPopup && (
        <AccountQuickView
          onClose={() => {
            setEmpPopup(false);
            setEmpData({});
          }}
          ClientList={Clients}
          UserList={usersList}
          onLoadMoreClients={() => loadClients(page + 1)}
          hasMoreClients={hasMoreClients}
          isLoadingClients={isLoadingClients}
          data={empData}
          ProductList={products}
          PackageList={PackageList}
          DealStages={DealStages}
        />
      )}

      {showLead && (
        <EmployeeDirectoryAddUpdate
          onClose={() => {
            setShowLead(false);
            setCurrentData({});
          }}
          data={currentData}
          tabIndex={0}
          onError={onError}
          onSubmit={onSuccess}
        />
      )}

      {bulkDataChange && (
        <BulkEdit
          onClose={() => {
            setBulkDataChange(false);
            setBulkDatavalue("");
          }}
          users={{ user_ids: selectedAccounts }}
          onError={onError}
          onSubmit={onSuccess}
        />
      )}

      {addWalletPopup && (
        <AddWallet
          onClose={() => {
            setAddWalletPopup(false);
            setSelectedUser({});
          }}
          onError={onError}
          onSubmit={onSuccess}
          selectedCustomerId={selectedUser}
        />
      )}

     

      <Snackbar
        open={alertData?.isShow}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert
          onClose={handleClose}
          severity={alertData?.type}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {alertData?.message}
        </Alert>
      </Snackbar>
    </>
  );
};

export default TeamAccounts;
